var _style, _g, _path, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemove = function SvgRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#777776;}.b{fill:white;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 2,
    className: "a"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7C12 17.4 12.6 18 13.3 18H18.7C19.4 18 20 17.4 20 16.7V10C20 9.3 19.4 8.7 18.7 8.7H13.3C12.6 8.7 12 9.3 12 10V16.7ZM14 10H18C18.4 10 18.7 10.3 18.7 10.7V16C18.7 16.4 18.4 16.7 18 16.7H14C13.6 16.7 13.3 16.4 13.3 16V10.7C13.3 10.3 13.6 10 14 10ZM18.3 6.7L17.9 6.2C17.7 6.1 17.6 6 17.4 6H14.6C14.4 6 14.3 6.1 14.1 6.2L13.7 6.7H12C11.6 6.7 11.3 7 11.3 7.3 11.3 7.7 11.6 8 12 8H20C20.4 8 20.7 7.7 20.7 7.3 20.7 7 20.4 6.7 20 6.7H18.3Z",
    className: "b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 24L16 27 12 24H20Z",
    className: "a"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    className: "b"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove.561b551b.svg";
export { ForwardRef as ReactComponent };